<div class="af-container margin-container">

  <div class="af-container__type">
    <div class="type-item" [ngClass]="{'type-selected':  typeAttachment == 1}" (click)="onChangeTypeAttachment(1)">
      <span>Carga por funciones</span>
    </div>
    <div class="type-item" [ngClass]="{'type-selected':  typeAttachment == 2}" (click)="onChangeTypeAttachment(2)">
      <span>Carga masiva</span>
    </div>
    <div class="type-item" [ngClass]="{'type-selected':  typeAttachment == 3}" (click)="onChangeTypeAttachment(3)">
      <span>Carga por número de empleado</span>
    </div>
  </div>
  <!-- ══════════════════════════════════════════════════════════
       SECCIÓN 1 — Carga masiva
  ══════════════════════════════════════════════════════════ -->
  <div class="af-section" *ngIf="typeAttachment == 1 || typeAttachment == 3">
    <h6 class="af-section__title"><strong>{{typeAttachment == 1 ? 'Carga por función' : 'Carga por numero de
        empleado'}}</strong></h6>

    <!-- Dropzone masivo -->
    <div class="af-dropzone" (dragover)="onBulkDragOver($event)" (drop)="onBulkDrop($event)">
      <label for="bulkFileInput" class="af-dropzone__label">
        <img src="../../../assets/svg/addfile.svg" alt="" width="20">
        <!-- <span class="af-dropzone__icon">📎</span> -->
        <span>Arrastra archivos aquí o <u>selecciona</u></span>
        <small class="af-dropzone__hint">PNG, JPG, MP4, PDF — máx. 15 MB por archivo</small>
      </label>
      <input id="bulkFileInput" type="file" multiple accept=".png,.jpg,.jpeg,.PNG,.JPG,.JPEG,.mp4,.MP4,.pdf,.PDF"
        style="display:none" (change)="onBulkFilesSelected($event)" />
    </div>

    <!-- Tabla de archivos cargados masivamente -->
    <div class="af-table-wrapper mt-3" *ngIf="bulkFiles.length > 0">
      <table class="table table-sm af-table">
        <thead>
          <tr>
            <th>#</th>
            <th>Nombre</th>
            <th>Tipo</th>
            <th>Estado</th>
            <th>Eliminar</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of bulkFiles; let i = index" [class.af-table__row--ok]="item.matched"
            [class.af-table__row--error]="!item.matched">
            <td>{{ i + 1 }}</td>
            <td>{{ item.name }}</td>
            <td>
              <span *ngIf="isImage(item.type)">Imagen</span>
              <span *ngIf="isVideo(item.type)">Video</span>
              <span *ngIf="isPdf(item.type)">PDF</span>
            </td>
            <td>
              <span *ngIf="item.matched" class="af-badge af-badge--ok">✔ Asignado</span>
              <span *ngIf="!item.matched" class="af-badge af-badge--error">
                ✖ El nombre no coincide con {{ typeAttachment === 3 ? 'algun número de empleado' : 'alguna función' }} existente
              </span>
            </td>
            <td>
              <button type="button" class="af-btn-icon" (click)="removeBulkFile(i)" title="Eliminar">
                <i class="fa fa-trash"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <p class="af-empty-hint" *ngIf="bulkFiles.length === 0">
      Aún no se han cargado archivos.
    </p>
  </div>

  <hr class="af-divider" />

  <!-- ══════════════════════════════════════════════════════════
       SECCIÓN 2 — Funciones / Puestos + Selector individual
  ══════════════════════════════════════════════════════════ -->
  <h6 *ngIf="typeAttachment == 1" class="af-section__title"><strong>Asignación por función</strong></h6>
  <h6 *ngIf="typeAttachment == 3" class="af-section__title"><strong>Asignación por número de empleado</strong></h6>


  <div *ngIf="typeAttachment == 1 || typeAttachment == 3" class="af-split">

    <!-- Panel izquierdo: lista de funciones -->
    <div class="af-split__left">
      <p class="af-split__subtitle">Selecciona {{ typeAttachment === 3 ? 'un número de empleado' : 'una función' }} para asignar su archivo</p>
      <ul *ngIf="typeAttachment == 1" class="af-funcion-list">
        <li *ngFor="let f of funciones" class="af-funcion-list__item"
          [class.af-funcion-list__item--active]="selectedFuncion?.funcionId === f.funcionId"
          [class.af-funcion-list__item--has-file]="hasAttachment(f.funcionId)" (click)="selectFuncion(f)">
          <span class="af-funcion-list__id">{{f.funcionId}}</span>
          <span class="af-funcion-list__name">{{ f.funcion | titlecase }}</span>
          <span class="af-funcion-list__indicator" *ngIf="hasAttachment(f.funcionId)" title="Tiene archivo asignado">●</span>
        </li>
      </ul>
      <ul *ngIf="typeAttachment == 3" class="af-funcion-list">
        <li *ngFor="let e of empleados" class="af-funcion-list__item"
          [class.af-funcion-list__item--active]="selectedEmpleado?.numeroEmpleado === e.numeroEmpleado"
          [class.af-funcion-list__item--has-file]="hasEmpleadoAttachment(e.numeroEmpleado)"
          (click)="selectEmpleado(e)">
          <span class="af-funcion-list__id">{{e.numeroEmpleado}}</span>
          <span class="af-funcion-list__name">{{ e.nombre | titlecase }}</span>
          <span class="af-funcion-list__indicator" *ngIf="hasEmpleadoAttachment(e.numeroEmpleado)" title="Tiene archivo asignado">●</span>
        </li>
      </ul>
    </div>

    <!-- Panel derecho: selector individual -->
    <div class="af-split__right">

      <!-- Tipo 1: ninguna función seleccionada -->
      <div class="af-preview-empty" *ngIf="typeAttachment == 1 && !selectedFuncion">
        <p>Selecciona una función de la lista para asignar o cambiar su archivo.</p>
      </div>

      <!-- Tipo 3: ningún empleado seleccionado -->
      <div class="af-preview-empty" *ngIf="typeAttachment == 3 && !selectedEmpleado">
        <p>Selecciona un número de empleado de la lista para asignar o cambiar su archivo.</p>
      </div>

      <!-- Tipo 1: Función seleccionada -->
      <ng-container *ngIf="typeAttachment == 1 && selectedFuncion">
        <p class="af-split__subtitle">
          Función: <strong>{{ selectedFuncion.funcion | titlecase }}</strong>
        </p>
        <div class="af-preview" *ngIf="hasAttachment(selectedFuncion.funcionId)">
          <ng-container *ngIf="getFuncionAttachment(selectedFuncion.funcionId) as entry">
            <img *ngIf="isImage(entry.type) && entry.previewUrl" [src]="entry.previewUrl" class="af-preview__img" alt="Preview" />
            <video *ngIf="isVideo(entry.type) && entry.previewUrl" [src]="entry.previewUrl" class="af-preview__video" controls preload="metadata"></video>
            <iframe *ngIf="isPdf(entry.type) && entry.previewUrl" [src]="entry.previewUrl | safeUrl" class="af-preview__pdf" frameborder="0"></iframe>
          </ng-container>
          <button type="button" class="af-btn-remove mt-2" (click)="removeIndividualAttachment()">
            <i class="fa fa-trash"></i> Quitar archivo
          </button>
        </div>
        <div class="af-individual-upload" [class.mt-3]="!hasAttachment(selectedFuncion.funcionId)">
          <label [for]="'individualFile_' + selectedFuncion.funcionId" class="af-btn-upload">
            <i class="fa fa-upload"></i>
            {{ hasAttachment(selectedFuncion.funcionId) ? 'Cambiar archivo' : 'Seleccionar archivo' }}
          </label>
          <input [id]="'individualFile_' + selectedFuncion.funcionId" type="file"
            accept=".png,.jpg,.jpeg,.PNG,.JPG,.JPEG,.mp4,.MP4,.pdf,.PDF" style="display:none"
            (change)="onIndividualFileSelected($event)" />
          <small class="af-dropzone__hint d-block mt-1">PNG, JPG, MP4, PDF</small>
        </div>
      </ng-container>

      <!-- Tipo 3: Empleado seleccionado -->
      <ng-container *ngIf="typeAttachment == 3 && selectedEmpleado">
        <p class="af-split__subtitle">
          Empleado: <strong>{{ selectedEmpleado.nombre | titlecase }}</strong>
          <span class="af-funcion-list__id ms-2">#{{selectedEmpleado.numeroEmpleado}}</span>
        </p>
        <div class="af-preview" *ngIf="hasEmpleadoAttachment(selectedEmpleado.numeroEmpleado)">
          <ng-container *ngIf="getEmpleadoAttachment(selectedEmpleado.numeroEmpleado) as entry">
            <img *ngIf="isImage(entry.type) && entry.previewUrl" [src]="entry.previewUrl" class="af-preview__img" alt="Preview" />
            <video *ngIf="isVideo(entry.type) && entry.previewUrl" [src]="entry.previewUrl" class="af-preview__video" controls preload="metadata"></video>
            <iframe *ngIf="isPdf(entry.type) && entry.previewUrl" [src]="entry.previewUrl | safeUrl" class="af-preview__pdf" frameborder="0"></iframe>
          </ng-container>
          <button type="button" class="af-btn-remove mt-2" (click)="removeIndividualAttachment()">
            <i class="fa fa-trash"></i> Quitar archivo
          </button>
        </div>
        <div class="af-individual-upload" [class.mt-3]="!hasEmpleadoAttachment(selectedEmpleado.numeroEmpleado)">
          <label [for]="'individualFileEmp_' + selectedEmpleado.numeroEmpleado" class="af-btn-upload">
            <i class="fa fa-upload"></i>
            {{ hasEmpleadoAttachment(selectedEmpleado.numeroEmpleado) ? 'Cambiar archivo' : 'Seleccionar archivo' }}
          </label>
          <input [id]="'individualFileEmp_' + selectedEmpleado.numeroEmpleado" type="file"
            accept=".png,.jpg,.jpeg,.PNG,.JPG,.JPEG,.mp4,.MP4,.pdf,.PDF" style="display:none"
            (change)="onIndividualFileSelected($event)" />
          <small class="af-dropzone__hint d-block mt-1">PNG, JPG, MP4, PDF</small>
        </div>
      </ng-container>
    </div>
  </div>

  <div *ngIf="typeAttachment == 2" class="af-split">
    <div class="af-split__left">
      <p class="instructions">Descarga el formato excel y llena las casillas con la información de la audiencia a la que va dirigida la
        información.</p>
      <button type="button" class="btn text-white btn-template"
        (click)="$event.preventDefault(); downloadFile('Carga_empleados')">
        <mat-icon class="icon-c-folder icon-display-button" svgIcon="icon-download"></mat-icon>
        Descargar formato
      </button>
      <p class="mt-3x  instructions">Una vez listo, súbelo y revisa que todo esté correcto.</p>
      <!-- DROPZONE SEGMENTACION-->
      <app-drop-zone (employeesArrayList)="onChangeEmployees($event)"
        (onUpdateSegmentation)="onUpdateSegmentation = $event" [fileName]="fileName" [editingBanner]="editingBanner">
      </app-drop-zone>
    </div>

    <div class="af-split__right">
      <div class="card">
        <div class=" card-header" style="display: flex; gap: 5px">
          <span class="header-audiencia" [ngClass]="{'selected-header': showAllowedEmployees}"
            (click)="showAllowedEmployees = true">Audiencia</span>
          <span class="header-audiencia" [ngClass]="{'selected-header': !showAllowedEmployees}"
            (click)="showAllowedEmployees = false">No encontrados</span>
        </div>
        <div class="card-body" style="height: 350px; overflow: auto;">
          <div class="row">
            <div>
              <app-validate-component [employeesArrayList]="employeesArrayList"
                [showAllowedEmployees]="showAllowedEmployees">
              </app-validate-component>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ng-container *ngIf="hasEmployeesFile && typeAttachment == 2" >
    <p class="mt-5 instructions">Selecciona la informacion que sera compartida con la audiencia seleccionada.</p>
    <!-- Preview del archivo actual -->
    <div class="af-preview mt-3" *ngIf="hasAttachmentNe()">
      <ng-container *ngIf="getNEAttachment() as entry">

        <!-- Imagen -->
        <img *ngIf="isImage(entry.type) && entry.previewUrl" [src]="entry.previewUrl" class="af-preview__img"
          alt="Preview" />

        <!-- Video -->
        <video *ngIf="isVideo(entry.type) && entry.previewUrl"
          [src]="entry.previewUrl"
          class="af-preview__video"
          controls
          preload="metadata">
        </video>

        <!-- PDF -->
        <iframe *ngIf="isPdf(entry.type) && entry.previewUrl"
          [src]="entry.previewUrl | safeUrl"
          class="af-preview__pdf"
          frameborder="0">
        </iframe>

      </ng-container>

      <button type="button" class="af-btn-remove mt-2" (click)="removeIndividualAttachment()">
        <i class="fa fa-trash"></i> Quitar archivo
      </button>
    </div>

    <div class="af-individual-upload" [class.mt-3]="!hasAttachmentNe()">
      <label [for]="'individualFileNe'" class="af-btn-upload">
        <i class="fa fa-upload"></i>
        {{ hasAttachmentNe() ? 'Cambiar archivo' : 'Seleccionar archivo' }}
      </label>
      <input [id]="'individualFileNe'" type="file" accept=".png,.jpg,.jpeg,.PNG,.JPG,.JPEG,.mp4,.MP4,.pdf,.PDF"
        style="display:none" (change)="onIndividualFileSelected($event)" />
      <small class="af-dropzone__hint d-block mt-1">PNG, JPG, MP4, PDF</small>
    </div>
  </ng-container>


</div>